<template>
  <div class="hosOrder">
    <h3>
      消息详情<span @click="complain">投诉</span>
      <el-button class="btn_top" @click="open" type="primary"
        >查看详情</el-button
      >
    </h3>
    <div class="tail">
      <span>订单跟踪：</span>
      <div>
        <p v-if="createdTime1(hospitalList.orderStatus)">
          <span class="time">{{ createdTime1(hospitalList.orderStatus) }}</span
          ><span>{{ orderStatus1(hospitalList.orderStatus) }}</span>
        </p>
        <p v-if="createdTime2(hospitalList.orderStatus)">
          <span class="time">{{ createdTime2(hospitalList.orderStatus) }}</span
          ><span>{{ orderStatus2(hospitalList.orderStatus) }}</span>
        </p>
        <p v-if="createdTime3(hospitalList.orderStatus)">
          <span class="time">{{ createdTime3(hospitalList.orderStatus) }}</span
          ><span>{{ orderStatus3(hospitalList.orderStatus) }}</span>
        </p>
        <p v-if="createdTime4(hospitalList.orderStatus)">
          <span class="time">{{ createdTime4(hospitalList.orderStatus) }}</span
          ><span>{{ orderStatus4(hospitalList.orderStatus) }}</span>
        </p>
        <p v-if="createdTime5(hospitalList.orderStatus)">
          <span class="time">{{ createdTime5(hospitalList.orderStatus) }}</span
          ><span>{{ orderStatus5(hospitalList.orderStatus) }}</span>
        </p>
        <p v-if="createdTime6(hospitalList.orderStatus)">
          <span class="time">{{ createdTime6(hospitalList.orderStatus) }}</span
          ><span>{{ orderStatus6(hospitalList.orderStatus) }}</span>
        </p>
      </div>
    </div>
    <div class="hospital">
      <div class="hos">
        <hospital-info />
      </div>
      <div class="doctor" v-for="(item, index) in doctorInfo" :key="index">
        <doctor-info :doctorInfo="item" />
      </div>
    </div>
    <div class="info">
      <div class="top">
        <span class="subject">{{ hospitalList.department }}</span>
        <p class="time">
          就诊时间： <span>{{ hospitalList.visitDate }}</span>
        </p>
      </div>
      <table>
        <tr>
          <td>姓名</td>
          <td>{{ hospitalList.name }}</td>
        </tr>
        <tr>
          <td>性别</td>
          <td>{{ hospitalList.sex == '1' ? "男" : "女" }}</td>
        </tr>
        <tr>
          <td>身份证号码</td>
          <td>{{ hospitalList.idCard }}</td>
        </tr>
        <tr>
          <td>联系方式</td>
          <td>{{ hospitalList.phone }}</td>
        </tr>
        <tr>
          <td>医院条码、病案号、一卡通号</td>
          <td>{{ hospitalList.barCode }}</td>
        </tr>
        <tr>
          <td>账号信息</td>
          <td>{{ hospitalList.accountInfo }}</td>
        </tr>
        <tr>
          <td>服务有效期</td>
          <td>{{ hospitalList.serviceDate }}</td>
        </tr>
        <tr>
          <td>备注信息</td>
          <td>{{ hospitalList.description }}</td>
        </tr>
        <tr>
          <td>追加备注</td>
          <td>{{ hospitalList.addRemark }}</td>
        </tr>
        <tr>
          <td>退回备注</td>
          <td>{{ hospitalList.refundRemark }}</td>
        </tr>
        <tr>
          <td>取消备注</td>
          <td>{{ hospitalList.cancelReason }}</td>
        </tr>
      </table>


      <div class="orderDetail">
        <div>
          <span>优惠券:</span>
          <span
            >{{ hospitalList.couponFee ? hospitalList.couponFee : 0 }}元</span
          >
        </div>
        <div>
          <span>服务费:</span>
          <span>{{ hospitalList.serverFee }}元</span>
        </div>
        <div>
          <span>加价:</span>
          <span>{{ hospitalList.addFee }}元</span>
        </div>
        <div>
          <span>诊金:</span>
          <span
            >{{
              hospitalList.diagnosisFee ? hospitalList.diagnosisFee : 0
            }}元</span
          >
        </div>
        <div>
          <span>溢价:</span>
          <span>{{ hospitalList.premiumFee }}元</span>
        </div>
        <div>
          <span>追加费用:</span>
          <span class="totalPrice">{{ hospitalList.addCostFee }}元</span>
        </div>
        <div>
          <span>退回费用:</span>
          <span class="totalPrice">{{ hospitalList.refundFee }}元</span>
        </div>
        <div class="total">
          <span>合计:</span>
          <span class="totalPrice">{{ hospitalList.payFee }}元</span>
        </div>
      </div>


      <div class="info" v-if="hospitalList.isEvaluate == 1">
        <div class="info_title" style="font-size:30px;margin:30px 0px;">评价</div>
        <table>
          <tr>
            <td>评价内容</td>
            <td>{{ hospitalList.evaluateContent }}</td>
          </tr>
          <tr>
            <td>评价星级</td>
            <td>
              <el-rate
                v-model="hospitalList.evaluateStar"
                disabled
                show-score
                text-color="#ff9900"
              >
              </el-rate>
            </td>
          </tr>
          <tr>
            <td>评价时间</td>
            <td>{{ hospitalList.evaluateDate }}</td>
          </tr>
        </table>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="info">
        <table>
          <tr>
            <td>预约编号</td>
            <td>{{ hospitalList.appointmentNo }}</td>
          </tr>
          <tr>
            <td>就诊人</td>
            <td>{{ hospitalList.name }}</td>
          </tr>
          <tr>
            <td>就诊医生</td>
            <td>{{ hospitalList.doctor }}</td>
          </tr>
          <tr>
            <td>医院/科室</td>
            <td>{{ hospitalList.hospital }}-{{ hospitalList.department }}</td>
          </tr>
           <tr>
            <td>费用</td>
            <td>{{ hospitalList.price }}</td>
          </tr>
          <tr>
            <td>就诊时间</td>
            <td>{{ hospitalList.startDate }}</td>
          </tr>
          <tr>
            <td>备注</td>
            <td>{{ hospitalList.remakes }}</td>
          </tr>
            <tr>
              <td>追加备注</td>
              <td>{{ hospitalList.addRemark }}</td>
            </tr>
            <tr>
              <td>退回备注</td>
              <td>{{ hospitalList.refundRemark }}</td>
            </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HospitalInfo from "../../../components/Hospital/HospitalInfo";
import DoctorInfo from "../../../components/Hospital/DoctorInfo";
import { reqDoctorOrderDetail } from "../../../api";
import { mapState } from "vuex";
export default {
  data() {
    return {
      hospitalList: {},
      dialogVisible: false,
    };
  },
  created() {
    const { id } = this.$route.query;
    reqDoctorOrderDetail(id).then((res) => {
      console.log(res);
      if (res.code === 200) {
        this.hospitalList = res.data.bussData;
        if(res.data.bussData.doctorId!=""){
        res.data.bussData.doctorDtos[0].isAgree = res.data.bussData.isAgree
        this.$store.dispatch("getDoctorInfo", res.data.bussData.doctorDtos);
        }
        this.$store.dispatch("getHospitalInfo", res.data.bussData.hospitalDto);
      }
    });
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    open() {
      this.dialogVisible = true;
    },
    // 投诉
    complain() {
      const { id } = this.$route.query;
      this.$router.push({ name: "Complain", query: { id } });
    },
    createdTime1(status) {
      return this.hospitalList.createDate;
    },
    createdTime2(status) {
      return this.hospitalList.accessDate;
    },
    createdTime3(status) {
      return this.hospitalList.paymentDate;
    },
    createdTime4(status) {
      return this.hospitalList.evaluateDate;
    },
    createdTime5(status) {
      return this.hospitalList.finishDate;
    },
    createdTime6(status) {
      return this.hospitalList.cancelDate;
    },
    orderStatus1(status) {
      return "待支付";
    },
    orderStatus2(status) {
      return "待抢单";
    },
    orderStatus3(status) {
      return "进行中";
    },
    orderStatus4(status) {
      return "待评价";
    },
    orderStatus5(status) {
      return "已完成";
    },
    orderStatus6(status) {
      return "已取消";
    },
  },
  computed: {
    ...mapState(["doctorInfo"]),
  },
  components: {
    HospitalInfo,
    DoctorInfo,
  },
};
</script>

<style scoped lang="less" type="text/less">
.btn_top {
  margin-left: 50px;
}
.hosOrder {
  h3 {
    font-size: 24px;
    margin-top: 60px;
    span {
      margin-left: 59px;
      font-size: 16px;
      color: #2fa1de;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .tail {
    margin-top: 29px;
    display: flex;
    p {
      margin-bottom: 15px;
      .time {
        margin-right: 20px;
      }
    }
  }
  .hospital {
    padding-bottom: 30px;
    border-bottom: 1px solid #e1e1e1;
    .hos {
      margin-top: 27px;
      margin-bottom: 31px;
    }
  }
  .info {
    .top {
      margin-top: 30px;
      margin-bottom: 21px;
      display: flex;
      .subject {
        font-size: 16px;
        font-weight: bold;
        margin-right: 25px;
      }
      .time {
        font-size: 16px;
        span {
          color: #2fa1de;
        }
      }
    }
    table {
      /*border:1px solid #e1e1e1;*/
      td {
        border: 1px solid #e1e1e1;
        &:first-of-type {
          width: 215px;
          height: 40px;
          line-height: 40px;
          text-indent: 20px;
        }
        &:last-of-type {
          width: 440px;
          height: 40px;
          line-height: 40px;
          padding: 0 30px;
          box-sizing: border-box;
        }
      }
    }
    .orderDetail {
      width: 569px;
      box-sizing: border-box;
      margin-top: 19px;
      padding: 30px 30px 20px;
      border: 4px solid #f1f1f1;
      div {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
        font-size: 16px;
        &.total {
          span {
            font-size: 20px;
            font-weight: 500;
            &:last-of-type {
              color: #e60012;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/HosOrder.vue